export default __webpack_public_path__ + "src/assets/ledger.d04ff8a1ca6f5bfea03900b8215348b0.svg";